import { author, getSummary } from '../data/profile';
import { Magnetic } from './Magnetic';
import './Hero.css';

interface HeroProps {
  time: string;
}

const githubUrl = 'https://github.com/denqxotl';
const githubGraphSrc = 'https://ghchart.rshah.org/denqxotl';

export function Hero({ time }: HeroProps) {
  const summary = getSummary();
  return (
    <section className="hero" id="top">
      <div className="hero-eyebrow" data-reveal>
        <span className="eyebrow-dot" />
        <span>Based in {author.location} · Remote worldwide</span>
        <span className="eyebrow-sep">/</span>
        <span className="mono">
          {time} {author.timezoneLabel}
        </span>
      </div>

      <div className="hero-meta" data-reveal>
        <div className="hero-portrait">
          <span className="hero-portrait-ring" />
          <img
            className="hero-portrait-img"
            src={`${process.env.PUBLIC_URL}${author.avatarSrc}`}
            alt={author.name}
            loading="eager"
            decoding="async"
          />
        </div>
        <div className="hero-name">
          <span className="hero-name-eyebrow">{author.handle}</span>
          <h1 className="hero-name-value">
            {author.name} <span className="hero-name-mark">/</span>{' '}
            <span className="hero-name-role">{author.role}</span>
          </h1>
        </div>
      </div>

      <p className="hero-summary" data-reveal>
        {summary}
      </p>

      <a
        id="github"
        className="hero-graph"
        href={githubUrl}
        target="_blank"
        rel="noreferrer"
        data-reveal
        aria-label="Open GitHub profile in a new tab"
      >
        <div className="hero-graph-top">
          <span className="mono">github.com/{author.shortHandle}</span>
          <span className="hero-graph-arrow" aria-hidden>↗</span>
        </div>
        <img
          className="contrib-graph"
          src={githubGraphSrc}
          alt={`GitHub contribution graph for ${author.shortHandle}`}
          loading="lazy"
        />
      </a>

      <div className="hero-cta" data-reveal>
        <Magnetic>
          <a className="btn btn-primary" href={`mailto:${author.email}`}>
            <span>Start a conversation</span>
            <span className="btn-arrow" aria-hidden>↗</span>
          </a>
        </Magnetic>
        <Magnetic>
          <a className="btn btn-ghost" href="#work">
            <span>See work history</span>
            <span className="btn-arrow" aria-hidden>↓</span>
          </a>
        </Magnetic>
      </div>
    </section>
  );
}
